import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import React from "react";
import { AgeFilterForm } from "../filters/AgeFilterForm";
import { AverageTicketFilterForm } from "../filters/AverageTicketFilterForm";
import { BirthdayFilterForm } from "../filters/BirthdayFilterForm";
import { ClimateProfileFilterForm } from "../filters/ClimateProfileFilterForm";
import { ConsumedProductsFilterForm } from "../filters/ConsumedProductsFilterForm";
import { ConsumptionMomentsFilterForm } from "../filters/ConsumptionMomentsFilterForm";
import { DaysWithoutConversionFilterForm } from "../filters/DaysWithoutConversionFilterForm";
import { LastConversionFilterForm } from "../filters/LastConversionFilterForm";
import { OrderCountFilterForm } from "../filters/OrderCountFilterForm";
import { OriginFilterForm } from "../filters/OriginFilterForm";
import { RegionFilterForm } from "../filters/RegionFilterForm";
import { RegisterTimeFilterForm } from "../filters/RegisterTimeFilterForm";
import { TotalSpendFilterForm } from "../filters/TotalSpendFilterForm";

export class FilterGroupForm extends React.Component {
  state = {
    selectedFilter: null,
  };

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      selectedFilter: node.data?.filters?.find((f) => f.selected),
    });
  }

  componentDidUpdate(prevProps) {
    const { visible, node } = this.props;
    if (!prevProps.visible && visible) {
      this.setState({
        selectedFilter: node.data?.filters?.find((f) => f.selected),
      });
    }
  }

  onChangeFilter(filter) {
    const { node, onChange } = this.props;

    for (const f of node.data?.filters) {
      if (f.selected) {
        f.data = filter.data;
      }
    }
    onChange && onChange(node);
    this.setState({ selectedFilter: filter });
  }

  saveGroup(filter) {
    const { node, onSave } = this.props;

    for (const f of node.data?.filters) {
      if (f.selected) {
        f.data = filter.data;
      }
    }
    onSave && onSave(node);
  }

  render() {
    const { visible, onClose } = this.props;
    const { selectedFilter } = this.state;

    const props = {
      title: selectedFilter?.type && BoxTitles[selectedFilter.type],
      visible: visible,
      onClose: onClose,
      node: selectedFilter,
      onChange: (n) => this.onChangeFilter(n),
      onSave: (n) => this.saveGroup(n),
    };

    switch (selectedFilter?.type) {
      case BoxTypes.AverageTicketFilter:
        return <AverageTicketFilterForm {...props} />;
      case BoxTypes.AgeFilter:
        return <AgeFilterForm {...props} />;
      case BoxTypes.RegionFilter:
        return <RegionFilterForm {...props} />;
      case BoxTypes.BirthdayFilter:
        return <BirthdayFilterForm {...props} />;
      case BoxTypes.OrderCountFilter:
        return <OrderCountFilterForm {...props} />;
      case BoxTypes.TotalSpendFilter:
        return <TotalSpendFilterForm {...props} />;
      case BoxTypes.RegisterTimeFilter:
        return <RegisterTimeFilterForm {...props} />;
      case BoxTypes.ClimateProfileFilter:
        return <ClimateProfileFilterForm {...props} />;
      case BoxTypes.LastConversionFilter:
        return <LastConversionFilterForm {...props} />;
      case BoxTypes.ConsumedProductsFilter:
        return <ConsumedProductsFilterForm {...props} />;
      case BoxTypes.ConsumptionMomentsFilter:
        return <ConsumptionMomentsFilterForm {...props} />;
      case BoxTypes.OriginFilter:
        return <OriginFilterForm {...props} />;
      case BoxTypes.DaysWithoutConversionFilter:
        return <DaysWithoutConversionFilterForm {...props} />;
      default:
        return null;
    }
  }
}
